<template>
  <div>
    <CList :pConfigList="ConfigList" :segurity="segurity">
        <template slot="Filtros">
            <div class="col-auto">
                <label class="col-form-label">Ejecutivas V:</label>
            </div>
            <div class="col-auto">
                <select @change="GetDatosGrafica" v-model="Filtro.IdVendedor" class="form-select form-control-search">
                    <option value="">Todos</option>
                    <option v-for="(item,ind) in Vendedores" :key="ind" :value="item.IdUsuario">{{item.NombreCompleto}}</option>
                </select>
            </div>
            <div class="col-auto">
                <label class="col-form-label">Gerentes o Cord:</label>
            </div>
            <div class="col-auto">
                <select @change="GetDatosGrafica" v-model="Filtro.IdContacto" class="form-select form-control-search">
                    <option value="">Todos</option>
                    <option v-for="(item,ind) in Coordinadores" :key="ind" :value="item.IdUsuario">{{item.NombreCompleto}}</option>
                </select>
            </div>
            <div class="col-auto">
                <label class="col-form-label">Hoteles / Empresas:</label>
            </div>
            <div class="col-auto">
                <select @change="GetDatosGrafica" v-model="Filtro.IdAgente" class="form-select form-control-search">
                    <option value="">Todos</option>
                    <option v-for="(item,ind) in Agentes" :key="ind" :value="item.IdAgente">{{item.NombreComercial}}</option>
                </select>
            </div>
            <div class="col-auto">
                <button class="btn btn-primary" @click="CambiarMostrarFechas">Por Fechas</button>
            </div>
            
            <div v-show="MostrarFechas" class="row g-3 justify-content-center px-4">
                <div class="col-auto">
                    <label for="">Por Meses</label>
                </div>
                <div class="col-auto">
                    <select @change="GetDatosGrafica" v-model="Filtro.Mes" class="form-select form-control-search">
                        <option value="">Todos</option>
                        <option v-for="(item,ind) in Meses" :key="ind" :value="item.Value">{{item.Tag}}</option>
                    </select>
                </div>
                <div class="col-auto">
                    <select @change="GetDatosGrafica" v-model="Filtro.Anio" class="form-select form-control-search">
                        <option v-for="(item,ind) in Anios" :key="ind" :value="item">{{item}}</option>
                    </select>
                </div>
                <div class="col-auto">
                    <label for="">o Por Rangos</label>
                </div>
                <div class="col-auto">
                    <Datepicker @input="GetDatosGrafica" v-model="Filtro.Inicio" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" placeholder="Fecha Inicial"></Datepicker>
                </div>
                <div class="col-auto">
                    <Datepicker @input="GetDatosGrafica" v-model="Filtro.Fin" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" placeholder="Fecha Final"></Datepicker>
                </div>
                <div class="col-auto">
                    <button @click="BorrarFechas" class="btn btn-primary"><i class="fa fa-trash"></i> Fechas</button>
                </div>
            </div>
            
        </template>

        <template slot="bodyForm">
            <CLoader :pConfigLoad="ConfigLoad">
                <template slot="BodyFormLoad">
                    <div class="row mt-3">
                        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="card text-white bg-primary h-100">
                                        <div class="card-body">
                                            <div class="card-body-icon">
                                                <i class="fa fa-fw fa-group"></i>
                                            </div>
                                            <h5 class="text-white">
                                                Cientes Creados
                                            </h5>
                                        </div>
                                        <div class="card-footer clearfix small z-index-1">
                                            <span style="float:left;font-size:15px;">Total</span>
                                            <span style="float:right; width:30px">
                                                <div class="circNum">
                                                    <p>{{ ClientesCreados }}</p>
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col-lg-12">
                                    <div class="card text-white bg-danger h-100">
                                        <div class="card-body">
                                            <div class="card-body-icon">
                                                <i class="fa fa-fw fa-times-circle"></i>
                                            </div>
                                            <h5 class="text-white">
                                                Cientes Descartados
                                            </h5>
                                        </div>
                                        <div class="card-footer clearfix small z-index-1">
                                            <span style="float:left;font-size:15px;">Total</span>
                                            <span style="float:right; width:30px">
                                                <div class="circNum">
                                                    <p>{{ ClientesDescartados }}</p>
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col-lg-12">
                                    <div class="card text-white bg-info h-100">
                                        <div class="card-body">
                                            <div class="card-body-icon">
                                                <i class="fa fa-fw fa-coins"></i>
                                            </div>
                                            <h5 class="text-white">
                                                Cotizaciones Activas
                                                <br>
                                                $ {{ MontoCotizacionesActivas }}
                                            </h5>
                                        </div>
                                        <div class="card-footer clearfix small z-index-1">
                                            <span style="float:left;font-size:15px;">Total de Cotizaciones</span>
                                            <span style="float:right; width:30px">
                                                <div class="circNum">
                                                    <p>{{ CotizacionesActivas }}</p>
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col-lg-12">
                                    <div class="card text-white bg-success h-100">
                                        <div class="card-body">
                                            <div class="card-body-icon">
                                                <i class="fa fa-fw fa-money-bill-alt"></i>
                                            </div>
                                            <h5 class="text-white">
                                                Cotizaciones Autorizadas
                                                <br>
                                                $ {{ MontoCotizacionesAutorizadas }}
                                            </h5>
                                        </div>
                                        <div class="card-footer clearfix small z-index-1">
                                            <span style="float:left;font-size:15px;">Total de Cotizaciones</span>
                                            <span style="float:right; width:30px">
                                                <div class="circNum">
                                                    <p>{{ CotizacionesAutorizadas }}</p>
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col-lg-12">
                                    <div class="card text-white bg-secondary h-100">
                                        <div class="card-body">
                                            <div class="card-body-icon">
                                                <i class="fa fa-fw fa-globe"></i>
                                            </div>
                                            <h5 class="text-white">
                                                Hoteles / Empresas Nuevas
                                            </h5>
                                        </div>
                                        <div class="card-footer clearfix small z-index-1">
                                            <span style="float:left;font-size:15px;">Total Pendientes</span>
                                            <span style="float:right; width:30px">
                                                <div class="circNum">
                                                    <p>{{ AgentesNuevos }}</p>
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div id="GraficaClientesSistema">
                                        <apexchart :height="GraficaClientesSistema.chartOptions.chart.height" :type="GraficaClientesSistema.chartOptions.chart.type" :options="GraficaClientesSistema.chartOptions" :series="GraficaClientesSistema.series"></apexchart>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-12">
                                    <div id="GraficaMontoCotizaciones">
                                        <apexchart :height="GraficaMontoCotizaciones.chartOptions.chart.height" :type="GraficaMontoCotizaciones.chartOptions.chart.type" :options="GraficaMontoCotizaciones.chartOptions" :series="GraficaMontoCotizaciones.series"></apexchart>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-12">
                                    <div id="GraficaEmpresasCreadas">
                                        <apexchart :height="GraficaEmpresasCreadas.chartOptions.chart.height" :type="GraficaEmpresasCreadas.chartOptions.chart.type" :options="GraficaEmpresasCreadas.chartOptions" :series="GraficaEmpresasCreadas.series"></apexchart>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </CLoader>
        </template>
    </CList>
  </div>
</template>

<script>
import Calendar from '@/helpers/StaticComboBox.js';
const EmitEjecuta='seccionIndicadorResultados'
export default {
    name:'IndicadorResultados',
    data() {
        return {
            ConfigList:{
                Title:'Indicador de Resultados',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: true,
                ShowPaginador: false,
                ShowSearch:false,
                ShowEntradas:false,
                TypeBody: 'Form',
				TitleFirst: 'Finanzas',
				EmitSeccion: EmitEjecuta,
            },
            ConfigLoad:{
                ShowLoader:true,
                ClassLoad:false
            },
            Filtro:{
                IdVendedor:'',
                IdContacto:'',
                IdAgente:'',
                Mes:'',
                Anio:new Date().getFullYear(),
                // Anio:'2023',
                Inicio:'',
                Fin:''
            },
            segurity:{},
            Setpicker:Calendar.calendarSettings,
            Vendedores:[],
            Coordinadores:[],
            Agentes:[],
            MostrarFechas:false,
            Meses:[
                {Tag:"Enero",Value:"1"},
                {Tag:"Febrero",Value:"2"},
                {Tag:"Marzo",Value:"3"},
                {Tag:"Abril",Value:"4"},
                {Tag:"Mayo",Value:"5"},
                {Tag:"Junio",Value:"6"},
                {Tag:"Julio",Value:"7"},
                {Tag:"Agosto",Value:"8"},
                {Tag:"Septiembre",Value:"9"},
                {Tag:"Octubre",Value:"10"},
                {Tag:"Noviembre",Value:"11"},
                {Tag:"Diciembre",Value:"12"}
            ],
            Anios:[],
            ClientesCreados:0,
            ClientesDescartados:0,
            MontoCotizacionesActivas:0,
            CotizacionesActivas:0,
            MontoCotizacionesAutorizadas:0,
            CotizacionesAutorizadas:0,
            AgentesNuevos:0,
            GraficaClientesSistema:{
                chartOptions:{
                    chart:{
                        type:'line',
                        height:'250'
                    },
                    stroke:{
                        curve:'smooth',
                        width:2
                    },
                    xaxis:{
                        categories:["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"]
                    },
                    yaxis:{
                        labels:{
                            formatter:(val)=>{
                                return val.toFixed(0);
                            }
                        },
                        title:{
                            text:'Cantidad'
                        }
                    },
                    dataLabels:{
                        enabled:true,
                        background:{
                            borderRadius:10
                        }
                    },
                    fill:{
                        colors:['#3B97B2']
                    },
                    colors:['#5E72E4','#F5365C'],
                    title: {
                        text: 'Clientes del Sistema',
                        align: 'center'
                    },
                },
                series:[]
            },
            GraficaMontoCotizaciones:{
                chartOptions:{
                    chart:{
                        type:'bar',
                        height:'350'
                    },
                    xaxis:{
                        categories:["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"]
                    },
                    yaxis:{
                        labels:{
                            formatter:(num)=>{
                                let fixed = 0;
                                if (num === null) { return null; } // terminate early
                                if (num === 0) { return '0'; } // terminate early
                                fixed = (!fixed || fixed < 0) ? 0 : fixed; // number of decimal places to show
                                const b = (num).toPrecision(2).split("e"), // get power
                                    k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
                                    c = k < 1 ? num.toFixed(0 + fixed) : (num / Math.pow(10, k * 3)).toFixed(1 + fixed), // divide by power
                                    d = c < 0 ? c : Math.abs(c), // enforce -0 is 0
                                    e = d + ['', ' K', ' M', ' B', ' T'][k]; // append power
                                return '$' + e;
                            }
                        },
                        title:{
                            text:'Montos $'
                        }
                    },
                    dataLabels:{
                        enabled:false
                    },
                    colors: ['#11CDEF', '#2DCE89'],
                    title: {
                        text: 'Monto de Cotizaciones',
                        align: 'center'
                    },
                },
                series:[]
            },
            GraficaEmpresasCreadas:{
                chartOptions:{
                    chart:{
                        type:'area',
                        height:'250'
                    },
                    title:{
                        text:"Historial de Empresas Creadas al Año",
                        align:"center"
                    },
                    xaxis:{
                        categories:["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"]
                    },
                    yaxis:{
                        labels:{
                            formatter:(val)=>{
                                return val.toFixed(0);
                            }
                        },
                        title:{
                            text:'Cantidad'
                        }
                    },
                },
                series:[]
            }
        }
    },
    methods: {
        async GetDatosGrafica(){
            this.ConfigLoad.ShowLoader=true;
            let FechaInicio='';
            let FechaFin='';
            if (this.Filtro.Inicio!='') {
                let YearInicio=this.Filtro.Inicio.getFullYear();
                let MonthInicio=this.Filtro.Inicio.getMonth()+1;
                let DayInicio=this.Filtro.Inicio.getDate();
                FechaInicio=YearInicio+'-'+MonthInicio+'-'+DayInicio;
            }
            if (this.Filtro.Fin!='') {
                let YearFin=this.Filtro.Fin.getFullYear();
                let MonthFin=this.Filtro.Fin.getMonth()+1;
                let DayFin=this.Filtro.Fin.getDate();
                FechaFin=YearFin+'-'+MonthFin+'-'+DayFin;
            }
            await this.$http.get('indicadorResultados',{
                params:{
                    IdVendedor:this.Filtro.IdVendedor,
                    IdContacto:this.Filtro.IdContacto,
                    IdAgente:this.Filtro.IdAgente,
                    Mes:this.Filtro.Mes,
                    Anio:this.Filtro.Anio,
                    Inicio:FechaInicio,
                    Fin:FechaFin
                }
            }).then((res)=>{
                this.ClientesCreados=res.data.data.ClientesCreados;
                this.ClientesDescartados=res.data.data.ClientesDescartados;
                this.MontoCotizacionesActivas=res.data.data.MontoCotizacionesActivas;
                this.CotizacionesActivas=res.data.data.CotizacionesActivas;
                this.MontoCotizacionesAutorizadas=res.data.data.MontoCotizacionesAutorizadas;
                this.CotizacionesAutorizadas=res.data.data.CotizacionesAutorizadas;
                this.AgentesNuevos=res.data.data.AgentesNuevos;
                this.GraficaClientesSistema.series=res.data.data.GraficaClientesSistema;
                this.GraficaMontoCotizaciones.series=res.data.data.GraficaMontoCotizaciones;
                this.GraficaEmpresasCreadas.series=res.data.data.GraficaEmpresasCreadas;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            })
        },
        CambiarMostrarFechas(){
            this.MostrarFechas=this.MostrarFechas ? false : true;
        },
        BorrarFechas(){
            this.Filtro.Inicio='';
            this.Filtro.Fin='';
            this.GetDatosGrafica();
        },
        GetFiltros(){
            this.$http.get('finanzasGraficasFiltros',{
                params:{
                    Anio:new Date().getFullYear(),
                    Vendedores:true,
                    Coordinadores:true
                }
            }).then((res)=>{
                this.Agentes=res.data.data.Agentes;
                this.Anios=res.data.data.Anios;
                this.Vendedores=res.data.data.Vendedores;
                this.Coordinadores=res.data.data.Coordinadores;
                this.Anios.push(new Date().getFullYear());
            })
        }
    },
    mounted() {
        this.GetFiltros();
        this.GetDatosGrafica();
    },
}
</script>

<style>

</style>